import { render } from "./app-system-secondary-layout.vue?vue&type=template&id=1590e5e6&scoped=true&ts=true"
import script from "./app-system-secondary-layout.vue?vue&type=script&lang=ts"
export * from "./app-system-secondary-layout.vue?vue&type=script&lang=ts"

import "./app-system-secondary-layout.vue?vue&type=style&index=0&id=1590e5e6&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1590e5e6"]])

export default __exports__